import {integrationDocumentationModule} from "./integrationDocumentationModule"
import {IStateParamsService, IStateProvider} from "angular-ui-router";
import {WsdlIdentifier} from "./integrationDocumentationService";

integrationDocumentationModule.config(($stateProvider: IStateProvider) => {
    $stateProvider
        .state("integrationDocumentation.documentation", {
            data: {
                pageTitle: "{{'title.configuration.server' | translate}}",
            },
            url: "/",
            template: `<nlg-integration-documentation></nlg-integration-documentation>`,
        })
        .state("integrationDocumentation.details", {
            data: {
                pageTitle: "{{'title.configuration.server' | translate}}",
            },
            url: "/{service}/{wsdlName}",
            template: `<nlg-integration-documentation-details wsdl-identifier="$resolve.identifier"></nlg-integration-documentation-details>`,
            resolve: {
                identifier($stateParams: IStateParamsService): WsdlIdentifier {
                    return {
                        wsdlName: $stateParams["wsdlName"],
                        service: $stateParams["service"]
                    }
                }
            }
        })
})